import React from 'react';
import { ShieldAlert } from 'lucide-react';

export interface ViolationBannerProps {
    /** Count of recorded proctoring violations (tab switches) this session. */
    violationCount: number;
    t: (key: string) => string;
}

/** Deliberately no "n of 3" limit — the attempt carries no violation-limit field to derive one from. */
export function ViolationBanner({ violationCount, t }: ViolationBannerProps) {
    const hasViolations = violationCount > 0;
    return (
        <div className="ts-card ts-violation-banner" role="status" aria-live="polite">
            <span className="ts-violation-banner-icon">
                <ShieldAlert size={18} />
            </span>
            <div className="ts-violation-banner-text">
                <span className="ts-violation-banner-title">{t('exam_monitoring_active')}</span>
                {hasViolations && (
                    <span className="ts-violation-banner-sub">
                        {violationCount}{' '}
                        {t(violationCount === 1 ? 'violation_recorded' : 'violations_recorded')}
                    </span>
                )}
            </div>
        </div>
    );
}
